<style lang="scss" scoped>
 .missing {
   color: hsl(0, 0%, 80%);
 }
</style>

<template>
  <div class="missing flex-c">
    <div class="is-size-1"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'missing'
};
</script>
